export default {
  // root path
  root: '',
  // Absolute Path
  twitter: '//twitter.com/sl360',
  sl360tourVido: '//vimeo.com/305828142',
  aboutUs: '//sl360.com/about.html',
  privacy: '//sl360.com/privacy.html',
  signUp: '//sl360.com/signup.html',
  home: '//www.usadata.com',
  wmsUrl: '//dev.sl360.com/wms/GetFeature.ashx?',
  mapData: '//www.sl360.com/map/GetData.ashx',

  // Nirvana.SalesLeads.Web as the root directory
  // page
  contactUs: 'contactus.html',
  pricing: 'faq/faqs-pricing.aspx',
  rewards: 'ba/reward.aspx',
  settings: 'ba/editprofile.aspx',
  redeemPoints: 'BA/Reward.aspx',
  logOut: 'logOut.aspx',
  aggrementPDF: 'oc/OrderLicenseTermsPDF.aspx',

  // services
  orderLeads: 'MailingLists.aspx?DataSource=',
  enhanceList: 'EnhanceList.aspx',
  cleanList: 'CleanList.aspx',
  emailAppend: 'BridgeEmail.aspx',
  emailVerification: 'EmailVerification.aspx',
  phoneAppend: 'PhoneAppend.aspx',
  reverseEmailAppend: 'ReverseEmailAppend.aspx',
  phoneReverse: 'PhoneReverse.aspx',
  phoneVerification: 'PhoneVerification.aspx',
  portraitReports: 'PortraitReports.aspx',
  datauseagreement: 'Dialogs/OrderLicenseTerms.aspx',
  mysavecount: 'rpt/MySavedCount.aspx',
  history: 'rpt/myordershistory.aspx',
  enhancelist: 'EnhanceList.aspx',
  cleanlist: 'CleanList.aspx',
  portaitreports: 'PortraitReports.aspx',

  // report
  reportLookALike: 'view/Look-Alike_Report.pdf',
  reportEnhanceLookAlike: 'view/Enhanced_Look-Alike_Report-R3494587.pdf',
  reportPortrait: 'view/Portrait Report.xls',
  reportPortraitRegional: 'view/Data Portrait Analysis (DPA) Sample_AC-0448-14.xlsx',
  reportPortraitNationwide: 'view/Data Portrait Analysis (DPA) Sample_AC-0448-14.xlsx',

  // action
  getSavedCount: 'urlgateway.aspx?type=SavedCountNoEmail&sessionid=',
  getOrderMoreCountGo: 'UrlGateway.aspx?Type=2',
  sendQuote: 'Dialogs/OrderQuoteNew.aspx',
  sampleExample: 'FileOutput/reports/report-output.html',

  // iframe
  breakDown: 'OC/ShowCountBreakdown.aspx?sid=',
  DownsuppressionTempFile: 'common/downloadfile.aspx?file=~/SuppressionTemplate.xls',
  reportBreakdown: 'OC/ShowCountBreakdownAndDetailReport.aspx',

  // sendMessage
  sendMessage: 'Controller/SaveController.ashx',

  // templates
  uploadMultipleAddressTemplates: 'common/downloadfile.aspx?file=~/RadiusAroundAnAddressTemplate.xls',
  radiusQuestion: '//op.usadata.com/sl360_helper/HelpGateway.aspx?pname=Radius%20Granularity&showEdit=false',
  agreementQuestion: '//op.usadata.com/sl360_helper/HelpGateway.aspx?pname=About%20Data%20Use%20Agreement&showEdit=false'
}



// WEBPACK FOOTER //
// ./src/config/link.js